<template>
	<div class="ingPage">
		<div class="content">
			<h2>
				{{
					tt('기존 랩매니저에서 랩매니저 PRO로 데이터 이전 중입니다.')
				}}
			</h2>
			<p
				v-html="
					tt(
						'최대 10분가량 소요되며, 이전 중에는 기존 랩매니저 서비스 사용이 제한됩니다. 데이터 이전이 완료되면, <b>이메일</b>과 <b>모바일 푸시 알림</b>을 통해 전달 드리겠습니다.'
					)
				"
			></p>
			<img src="@/assets/images/transfer.png" />
			<span>{{ timeText }} 초과</span>
			<b @click="clickHowToMigration">{{
				tt('데이터는 어떻게 이전되나요?')
			}}</b>
		</div>
	</div>
</template>

<script>
import ModalIframe from '@/views/inventory/modals/ModalInventoryMSDS.vue'
import { openExternal } from '@/utils/modules/WebBridge'
export default {
	name: 'MigrationIngPage',
	props: ['data'],
	components: {
		ModalIframe,
	},
	data() {
		return {
			timer: null,
			now: null,
		}
	},
	created() {
		this.timer = setInterval(() => {
			this.now = new Date()
		}, 1000)
	},
	unmounted() {
		clearInterval(this.timer)
	},
	computed: {
		timeText() {
			const duration = Math.floor(
				(this.now - new Date(this.data.startDatetime)) / 1000
			)

			let min = Math.floor(duration / 60)
			let sec = duration % 60

			if (min < 0) min = 0
			if (sec < 0) sec = 0

			return `${min > 10 ? min : `0${min}`}:${sec > 10 ? sec : `0${sec}`}`
		},
	},
	methods: {
		clickHowToMigration() {
			openExternal(
				'https://smartjack.notion.site/PRO-ba63ad98f3ea470bb011bdf877d956a4'
			)
		},
	},
}
</script>

<style lang="scss" scoped>
.ingPage {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	height: calc(var(--vh, 1vh) * 100);
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 0 28px;
	z-index: 1000;
	.content {
		h2 {
			font-size: 2rem;
			font-weight: 700;
			word-break: keep-all;
			letter-spacing: -0.08rem;
		}
		p {
			font-size: 0.875rem;
			font-weight: 400;
			color: #111;
			margin: 30px 0;
			line-height: 1.6;
			word-break: keep-all;
		}
		img {
			width: 200px;
			height: 200px;
		}
		span {
			display: block;
			font-size: 0.875rem;
			color: #000;
			font-weight: 400;
		}
		> b {
			font-size: 0.875rem;
			font-weight: 700;
			display: block;
			color: #666;
			text-decoration: underline;
			margin-top: 30px;
		}
	}
}
</style>
